import { registerModule } from '@vue-storefront/core/lib/modules'
import type VueRouter from 'vue-router'

/** Theme routes that use the `wordpress` Vuex namespace (see SliderBlog → PostsIndex on home). */
const ROUTES_NEEDING_WORDPRESS = new Set(['home', 'posts-index', 'posts-show'])

const ROUTER_MARKER = '__VSF_WORDPRESS_LAZY_GUARD__'

let wordpressModulePromise: Promise<void> | null = null

function loadWordpressStorefrontModule (): Promise<void> {
  if (!wordpressModulePromise) {
    wordpressModulePromise = import(
      /* webpackChunkName: "vsf-wordpress-module" */ './storefront-module'
    ).then(({ Wordpress }) => {
      registerModule(Wordpress)
    })
  }
  return wordpressModulePromise
}

/**
 * Registers the Wordpress Vuex module only when navigating to routes that need it,
 * so the store implementation stays in an async chunk for catalog-heavy sessions.
 */
export function installWordpressLazyRegistration (router: VueRouter): void {
  const r = router as VueRouter & { [ROUTER_MARKER]?: boolean }
  if (r[ROUTER_MARKER]) {
    return
  }
  r[ROUTER_MARKER] = true

  router.beforeEach(async (to, _from, next) => {
    const name = to.name != null ? String(to.name) : ''
    if (!name || !ROUTES_NEEDING_WORDPRESS.has(name)) {
      next()
      return
    }
    try {
      await loadWordpressStorefrontModule()
    } catch (err) {
      if (typeof console !== 'undefined' && console.error) {
        console.error('[wordpress] failed to load module', err)
      }
    }
    next()
  })
}
